import { connect } from "react-redux";
import { RootState } from "app/rootReducer";
import { fetchUserProfile as onFetchUserProfile } from "features/user/reducer";
import { signOut as onSignOut } from "features/auth/reducer";
import ProfileView from "./ProfileView";

const mapStateToProps = (state: RootState) => ({
    club: state.calendar.club,
    userProfile: state.user.profile,
});

const mapDispatchToProps = {
    onFetchUserProfile,
    onSignOut,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileView);
